import { render, staticRenderFns } from "./SmallSearchResult.vue?vue&type=template&id=2c404b8e&scoped=true&"
import script from "./SmallSearchResult.vue?vue&type=script&lang=ts&"
export * from "./SmallSearchResult.vue?vue&type=script&lang=ts&"
import style0 from "./SmallSearchResult.vue?vue&type=style&index=0&id=2c404b8e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c404b8e",
  null
  
)

export default component.exports